import React from 'react';

import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/solid';

import { usePlatformSettings } from 'shared-lib';
import { ActionContainer, Button, EdLink, Size } from 'shared-ui';
import { AppLogo } from 'app-core';

export const HomePage = () => {
  const settings = usePlatformSettings();

  return (
    <div
      className="flex h-screen bg-gray-100 xl:bg-[url('https://images.pexels.com/photos/4087576/pexels-photo-4087576.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2')] 
    "
    >
      <div className='xl:bg-primary-200 border-primary-400 flex h-screen w-full flex-col justify-between p-5 xl:w-5/12 xl:border-r-2 xl:bg-none '>
        <div className='mb-10 mt-5 flex justify-center md:grow md:items-center'>
          <div className='flex flex-col gap-5'>
            <div className='flex w-full justify-center'>
              {/* <h1 className='text-xl font-medium text-primary-900 text-center'>
                {settings ? `Welcome to ${settings.name}` : `Welcome`}
              </h1> */}
              <div className='flex md:hidden'>
                <AppLogo />
              </div>
            </div>

            <ActionContainer
              titleBottom={
                <div className='hidden self-end md:flex'>
                  <AppLogo />
                </div>
              }
              buttonElement={
                <div className='w-sm'>
                  <EdLink name='candidates' href='candidates'>
                    <Button color='primary' name='Start Here' size={Size.xl}>
                      <div className='mx-1 flex items-center gap-1'>
                        <div className='whitespace-nowrap text-sm'>
                          Start Here
                        </div>
                        <ArrowRightIcon className='h-5 w-5' />
                      </div>
                    </Button>
                  </EdLink>
                </div>
              }
            >
              <div className='text-primary-900 text-center text-2xl font-medium'>
                Job Seekers & Contractors
              </div>
            </ActionContainer>

            <ActionContainer
              titleBottom={
                <div className='hidden self-end md:flex'>
                  <AppLogo />
                </div>
              }
              buttonElement={
                <div className='w-sm'>
                  <EdLink name='employers' href='employers'>
                    <Button color='primary' name='Start Here' size={Size.xl}>
                      <div className='mx-1 flex items-center gap-1'>
                        <div className='whitespace-nowrap text-sm'>
                          Start Here
                        </div>
                        <ArrowRightIcon className='h-5 w-5' />
                      </div>
                    </Button>
                  </EdLink>
                </div>
              }
            >
              <div className='text-primary-900 text-center text-2xl font-medium'>
                Employers
              </div>
            </ActionContainer>
          </div>
        </div>
        <div className='mb-4 flex justify-end'>
          <div className='p-2'>
            <Link to='admin'>Admin</Link>
          </div>
        </div>
      </div>
      <div
        className={
          "hidden h-screen grow bg-[url('https://images.pexels.com/photos/4087576/pexels-photo-4087576.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2')] bg-cover xl:flex"
        }
      ></div>
    </div>
  );
};
